import React from 'react';
import PropTypes from 'prop-types';
import styles from './FullScreenLoader.scss';
import { Loader } from 'wix-style-react';

export default function FullScreenLoader() {
  return (
    <div className={styles.container}>
      <Loader />
    </div>
  );
}

FullScreenLoader.displayName = 'FullScreenLoader';
FullScreenLoader.propTypes = {
  foo: PropTypes.string,
};
